import { Subscription } from '@wix/ambassador-billing-v1-subscription/types';
import React from 'react';
import { TextButton } from 'wix-ui-tpa';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { connect } from '../../../../common/components/runtime-context';
import { IActionCreators } from '../../../../types/internal-types';
import { RootState } from '../../state';
import { getMaxUserActions } from '../../selectors';
import { DisabledCtaTooltip } from './DisabledCtaTooltip';
import { classes } from './SubscriptionsListItemBass.st.css';

export const SKIP_SUBSCRIPTION_CTA_DATA_HOOKS = {
  button: 'subscription-skip-button',
  tooltip: 'subscription-skip-limit-tooltip',
};

type RuntimeProps = ReturnType<typeof mapRuntimeToProps>;

interface Props {
  subscription: Subscription;
  disabled?: boolean;
}
const SkipSubscriptionCta = ({ subscription, disabled, maxUserActions, actionCreators }: Props & RuntimeProps) => {
  const { t } = useTranslation();
  const button = (
    <TextButton
      data-hook={SKIP_SUBSCRIPTION_CTA_DATA_HOOKS.button}
      className={classes.cta}
      disabled={disabled}
      onClick={() => {
        actionCreators.openSkipConfirmModal(subscription.id!);
      }}
    >
      {t('app.subscription.overviewModal.skipOrdersCta')}
    </TextButton>
  );

  if (!disabled) {
    return button;
  }

  return (
    <DisabledCtaTooltip
      dataHook={SKIP_SUBSCRIPTION_CTA_DATA_HOOKS.tooltip}
      content={t('app.subscription-status.popover.tooltip.skipLimitMessage', { count: maxUserActions })}
    >
      {button}
    </DisabledCtaTooltip>
  );
};

const mapRuntimeToProps = (state: RootState, { subscription }: Props, actionCreators: IActionCreators) => {
  return {
    actionCreators,
    maxUserActions: getMaxUserActions(state, subscription),
  };
};

export default connect(mapRuntimeToProps)(SkipSubscriptionCta);
